export default "__VITE_ASSET__Cb$Sxp2f__"